import { useEffect, useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { Box, Tab, Tabs } from "@mui/material";
import { APP_ROUTES } from "../../config/appRoutes";
import { useData } from "../../context/DataContext";
import HistoryIcon from "@mui/icons-material/History";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { getClientTheme } from "../../theme/clientTheme";

const TAB_ROUTES = {
    0: APP_ROUTES.TRAININGSESSION.HISTORY,
    1: APP_ROUTES.TRAININGSESSION.CREATION,
};

function Training() {
    const navigate = useNavigate();
    const location = useLocation();
    const { user_client_id, user = {} } = useData();
    const clientTheme = getClientTheme(user_client_id);
    const clientId = user_client_id;
    const [tab, setTab] = useState(0);

    // Handle tab change
    const handleTabChange = (_, newValue) => {
        setTab(newValue);
        navigate(TAB_ROUTES[newValue]);
    };

    // Sync tab with URL
    useEffect(() => {
        if (location.pathname.includes(APP_ROUTES.TRAININGSESSION.CREATION)) {
            setTab(1);
        } else {
            setTab(0);
        }
    }, [location.pathname]);

    return (
        <>
            {
                location.pathname.includes(APP_ROUTES.TRAININGSESSION.HISTORY_ROUTES.FEEDBACK) ||
                    location.pathname.includes(APP_ROUTES.TRAININGSESSION.HISTORY_ROUTES.ATTENDANCE) ||
                    location.pathname.includes(APP_ROUTES.TRAININGSESSION.HISTORY_ROUTES.SISSIONPLAN_HISTORY)
                    ? ""
                    : <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
                        <Tabs value={tab} onChange={handleTabChange} TabIndicatorProps={{
                            style: {
                                backgroundColor: clientId === 1 ? "#2e7d32" : clientTheme.activeBg,
                            },
                        }}>
                            <Tab label="Session Details" icon={<HistoryIcon />} iconPosition="start" sx={{
                                color: clientId === 1 ? "success.main" : "#000",
                                "&.Mui-selected": {
                                    color: clientId === 1 ? "success.main" : "#000",
                                },
                            }} />
                            {user.user_level_id === 4 && (
                                <Tab label="Create Session" icon={<AddCircleOutlineIcon />} iconPosition="start" sx={{
                                    color: clientId === 1 ? "success.main" : "#000",
                                    "&.Mui-selected": {
                                        color: clientId === 1 ? "success.main" : "#000",
                                    },
                                }} />
                            )}
                        </Tabs>
                    </Box>
            }

            <Outlet />
        </>
    );
}

export default Training;
